import { createRouter, createWebHashHistory } from 'vue-router'

import PageHome from '@/views/PageHome.vue'
import BeritaOPD from '@/views/berita/BeritaOPD.vue'
import isi_berita from '@/views/berita/isi_berita.vue'

import TugasPokok from '@/views/profil/1TugasPokok.vue'
import StrukturOrganisasi from '@/views/profil/2StrukturOrganisasi.vue'
import TujuanSasaran from '@/views/profil/3TujuanSasaran.vue'
import VisiMisi from '@/views/profil/4VisiMisi.vue'
// import ProfilPegawai from '@/views/profil/ProfilPegawai.vue'

 
 
import SekretariatOPD                     from '@/views/unit_kerja/1Sekretariat.vue'   
import PenyiapanKawasandanPembangunanTransmigrasi                     from '@/views/unit_kerja/2PenyiapanKawasandanPembangunanTransmigrasi.vue'   
import PembinaandanPengembanganKawasanTransmigrasi                     from '@/views/unit_kerja/3PembinaandanPengembanganKawasanTransmigrasi.vue'   
import HubunganIndustrialdanPerlindunganTenagaKerja                     from '@/views/unit_kerja/4HubunganIndustrialdanPerlindunganTenagaKerja.vue'   
import PenempatandanPelatihanTenagaKerja                     from '@/views/unit_kerja/5PenempatandanPelatihanTenagaKerja.vue'   


import DataUmum        from '@/views/data/1DataUmum.vue'   
import DataPerizinan   from '@/views/data/2DataPerizinan.vue'   
import DataPPID        from '@/views/data/3DataPPID.vue'   
import DataUMK         from '@/views/data/4DataUMK.vue'   
import DataUPTD        from '@/views/data/5DataUPTD.vue'   


// import LayananOpd from '@/views/layanan/LayananOPD.vue'
// import IsiLayanan from '@/views/layanan/IsiLayanan.vue'


// import InformasiDinsos from '@/views/informasi/InformasiDinsos.vue' 
// import KontakDinsos from '@/views/kontak/KontakDinsos.vue' 

import Pekerjaan from '@/views/layanan/1Pekerjaan.vue' 
import Peraturan from '@/views/layanan/2Peraturan.vue' 
import HubunganIndustri from '@/views/layanan/3HubunganIndustri.vue' 
import PelatihanKerja from '@/views/layanan/4PelatihanKerja.vue' 
import PenempatanTenagaKerja from '@/views/layanan/5PenempatanTenagaKerja.vue' 
import PengawasanTenagaKerja from '@/views/layanan/6PengawasanTenagaKerja.vue' 


// import TeleponPenting from '@/views/informasi/1TeleponPenting.vue' 
// import TitikRawanKebakaran from '@/views/informasi/2TitikRawanKebakaran.vue' 
// import TitikRawanBahaya from '@/views/informasi/3TitikRawanBahaya.vue' 
// import PeralatanSaranaPrasarana from '@/views/informasi/4PeralatanSaranaPrasarana.vue' 

import DataLainnya from '@/views/data/DataLainnya.vue' 


import FotoOPD from '@/views/galeri/FotoOPD.vue'
import VideoOPD from '@/views/galeri/VideoOPD.vue'

const routes = [
  { path: '/', name: 'home', component: PageHome },
  { path: '/BeritaOPD', name: 'BeritaOPD', component: BeritaOPD },
  { path: '/isi_berita', name: 'isi_berita', component: isi_berita },

  
  { path: '/TugasPokok',           name: 'Tugas Pokok',           component: TugasPokok },
  { path: '/StrukturOrganisasi',   name: 'Struktur Organisasi',   component: StrukturOrganisasi },
  { path: '/TujuanSasaran',        name: 'Tujuan Sasaran',        component: TujuanSasaran },
  { path: '/VisiMisi',             name: 'Visi Misi',             component: VisiMisi }, 
  
  //=====================================
   
  { path: '/SekretariatOPD',                                      name: 'Sekretariat',                      component: SekretariatOPD },   
  { path: '/PenyiapanKawasandanPembangunanTransmigrasi',          name: 'Penyiapan Kawasan dan Pembangunan Transmigrasi',                      component: PenyiapanKawasandanPembangunanTransmigrasi },   
  { path: '/PembinaandanPengembanganKawasanTransmigrasi',         name: 'Pembinaandan Pengembangan Kawasan Transmigrasi',                      component: PembinaandanPengembanganKawasanTransmigrasi },   
  { path: '/HubunganIndustrialdanPerlindunganTenagaKerja',        name: 'Hubungan Industrial dan Perlindungan TenagaKerja',                      component: HubunganIndustrialdanPerlindunganTenagaKerja },   
  { path: '/PenempatandanPelatihanTenagaKerja',                   name: 'Penempatan dan Pelatihan Tenaga Kerja',                      component: PenempatandanPelatihanTenagaKerja },   

  { path: '/DataUmum',            name: 'Data Umum',            component: DataUmum },   
  { path: '/DataPerizinan',       name: 'Data Perizinan',       component: DataPerizinan },   
  { path: '/DataPPID',            name: 'Data PPID',            component: DataPPID },   
  { path: '/DataUMK',             name: 'Data UMK',             component: DataUMK },   
  { path: '/DataUPTD',            name: 'Data UPTD',            component: DataUPTD },   
  
  { path: '/LayananPekerjaan',               name: 'Pekerjaan',                 component: Pekerjaan },   
  { path: '/LayananPeraturan',               name: 'Peraturan',                 component: Peraturan },   
  { path: '/LayananHubunganIndustri',        name: 'Hubungan Industri',          component: HubunganIndustri },   
  { path: '/LayananPelatihanKerja',          name: 'Pelatihan Kerja',            component: PelatihanKerja },   
  { path: '/LayananPenempatanTenagaKerja',   name: 'Penempatan Tenaga Kerja',     component: PenempatanTenagaKerja },   
  { path: '/LayananPengawasanTenagaKerja',   name: 'Pengawasan Tenaga Kerja',     component: PengawasanTenagaKerja },   


  // { path: '/TeleponPenting',                name: 'Telepon Penting',                        component: TeleponPenting },
  // { path: '/TitikRawanKebakaran',           name: 'Titik Rawan Kebakaran',                  component: TitikRawanKebakaran },
  // { path: '/TitikRawanBahaya',              name: 'Titik Rawan Bahaya',                     component: TitikRawanBahaya },
  // { path: '/PeralatanSaranaPrasarana',      name: 'Peralatan Sarana & Prasarana',           component: PeralatanSaranaPrasarana },

  // { path: '/LayananSekretariatDinasSosial',                name: 'Sekretariat Dinas Sosial',                  component: LayananOpd },
  // { path: '/LayananBidangPenangananFakirMiskin',           name: 'Bidang Penanganan Fakir Miskin',            component: LayananOpd },
  // { path: '/LayananBidangPerlindunganJaminanSosial',       name: 'Bidang Perlindungan dan Jaminan Sosial',    component: LayananOpd },
  // { path: '/LayananBidangRehabilitasSosial',               name: 'Bidang Rehabilitas Sosial',                 component: LayananOpd },
  // { path: '/LayananBidangPemerdayaanSosial',               name: 'Bidang Pemerdayaan Sosial',                 component: LayananOpd },
  // { path: '/IsiLayanan',          name: 'Isi Layanan',             component: IsiLayanan },


  // { path: '/InformasiDinsos',          name: 'Informasi Dinsos',             component: InformasiDinsos }, 
  
  // { path: '/Kontak',          name: 'Hubungi Kami',             component: KontakDinsos }, 
  
  
  { path: '/DataLainnya', name: 'Dokumen Lainnya', component: DataLainnya },
  
  { path: '/FotoOPD', name: 'FotoKB', component: FotoOPD },
  { path: '/VideoOPD', name: 'VideoKB', component: VideoOPD },
]

const router = createRouter({
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
      behavior: 'smooth'
     }
  },
  history: createWebHashHistory(),
  routes,
})

export default router
